export default __webpack_public_path__ + "static/media/CallToActionDeliverer.aeb8a6b6.jpg";